module.exports = __webpack_public_path__ + "img/echp-logo-no-sac-copy2.864d9530.png";